import { Button, Container, Group, Stack, Tabs, Text, Title } from '@mantine/core';
import { LocalhostOnlyBadge } from '@/components/LocalhostOnlyBadge';
import { useDisclosure } from '@mantine/hooks';
import { useMedplum } from '@medplum/react-hooks';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { config } from '@/config';
import { BillingDevCreateModal } from './components/BillingDevCreateModal';
import {
  BILLING_TAB_ITEMS,
  billingActiveTab,
  billingHidesSecondaryNav,
  billingShowsDevCreate,
} from './billingNavConfig';

export function BillingSectionLayout(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();
  const medplum = useMedplum();
  const showTabs = !billingHidesSecondaryNav(location.pathname);
  const activeTab = billingActiveTab(location.pathname);
  const showDevCreate = billingShowsDevCreate(location.pathname, config.profile);
  const [devCreateOpened, { open: openDevCreate, close: closeDevCreate }] = useDisclosure(false);
  const activeTabItem = BILLING_TAB_ITEMS.find((item) => item.tab === activeTab);

  const handleOpenDevCreate = (): void => {
    medplum.invalidateSearches('Practitioner');
    medplum.invalidateSearches('EpisodeOfCare');
    medplum.invalidateSearches('CareTeam');
    medplum.invalidateSearches('Patient');
    openDevCreate();
  };

  return (
    <Container size="xl" py="xl">
      <Stack gap="lg">
        {showTabs ? (
          <>
            <Group justify="space-between" align="center">
              <Group gap="sm" align="center" wrap="wrap">
                <Title order={2}>Billing</Title>
                <LocalhostOnlyBadge />
              </Group>
              {showDevCreate ? (
                <Button variant="default" onClick={handleOpenDevCreate}>
                  (DEV) Create
                </Button>
              ) : null}
            </Group>
            <Tabs
              value={activeTab}
              onChange={(value) => {
                const item = BILLING_TAB_ITEMS.find((tab) => tab.tab === value);
                if (item) navigate(item.to);
              }}
            >
              <Tabs.List
                style={{
                  flexWrap: 'nowrap',
                  overflowX: 'auto',
                  scrollbarWidth: 'thin',
                }}
              >
                {BILLING_TAB_ITEMS.map((item) => (
                  <Tabs.Tab
                    key={item.tab}
                    value={item.tab}
                    style={{ flexShrink: 0 }}
                  >
                    {item.label}
                  </Tabs.Tab>
                ))}
              </Tabs.List>
            </Tabs>
          </>
        ) : (
          <Text size="sm" c="dimmed">
            Billing
          </Text>
        )}
        <Outlet />
      </Stack>
      {showDevCreate ? (
        <BillingDevCreateModal
          opened={devCreateOpened}
          onClose={closeDevCreate}
          activeTab={activeTab}
          activeTabLabel={activeTabItem?.label ?? activeTab}
        />
      ) : null}
    </Container>
  );
}
